import { LitElement, html, svg } from 'lit';

export class IconCharger32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Kabel</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 21a8 8 0 0 1-8-8V9a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a8 8 0 0 1-8 8ZM8 7V1M16 7V1"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M28 31v-6a4 4 0 1 0-8 0 4 4 0 1 1-8 0v-3.953M10 11h4"></path></svg>`; }
}
if (!customElements.get('f-icon-charger32', IconCharger32)) {
  customElements.define('f-icon-charger32', IconCharger32);
}